import React, { Component } from 'react';
import PropTypes from 'prop-types';
import BillingInformation from '../../../../../../../Account/components/Subscription/BillingInformation';
import BraintreePaymentForm from '../../../../../../../Account/components/Subscription/BraintreePaymentForm';
import FSFlatButton from '../../../../../../../../src/components/lib/FSFlatButton';

export default class NewPayment extends Component {
  static propTypes = {
    braintreeSubmitButtonDisabled: PropTypes.bool,
    hostedFields: PropTypes.object,
    hostedFieldsDidCreate: PropTypes.func,
    user: PropTypes.object.isRequired,
    updateProfile: PropTypes.func.isRequired,
    braintreeClientToken: PropTypes.string,
    submitPayment: PropTypes.func.isRequired,
    cancelAction: PropTypes.func.isRequired,
    toast: PropTypes.object.isRequired,
    disableButtonsWhileLoading: PropTypes.bool,
    validateTermsChecked: PropTypes.func,
    dispatch: PropTypes.func,
  };

  constructor(props, context) {
    super(props, context);

    this.billingInfo = null;
    this.braintreePaymentForm = null;
  }

  _onPaymentFormSubmitted = () => {
    this.props.submitPayment({
      checked: this.braintreePaymentForm.termsCheckbox.checked,
      billingFormSubmit: this.billingInfo.submitForm,
      braintreeFormSubmit: this.braintreePaymentForm.sendPaymentMethod,
    });
  }

  handleCheckBox = (checked) => {
    if (checked) {
      const { dispatch, validateTermsChecked } = this.props;

      dispatch(validateTermsChecked(true));
    }
  }

  render() {
    return (
      <div className='NewPayment'>
        <p className='fine-text'>This billing address and credit card information will become the default payment method for future exports and subscriptions.</p>
        <div className='row equal'>
          <div className='col-xs-12 col-sm-5'>
            <BillingInformation
              user={this.props.user}
              ref={(ref) => { this.billingInfo = ref; }}
              updateProfile={this.props.updateProfile}
            />
          </div>
          <div className='col-xs-12 col-sm-offset-1 col-sm-6 col-md-5'>
            {this.props.braintreeClientToken ?
              <BraintreePaymentForm
                braintreeSubmitButtonDisabled={this.props.braintreeSubmitButtonDisabled}
                hostedFields={this.props.hostedFields}
                hostedFieldsDidCreate={this.props.hostedFieldsDidCreate}
                clientToken={this.props.braintreeClientToken}
                dispatch={this.props.dispatch}
                ref={(ref) => { this.braintreePaymentForm = ref; }}
                onPaymentFormSubmitted={this._onPaymentFormSubmitted}
                user={this.props.user}
                updateProfile={this.props.updateProfile}
                isGeneralPaymentForm
                termsLink='https://www.flightstats.com/company/legal/flightstats-historical-data-export-license-terms-and-conditions/'
                termsText='Data Export'
                handleCheckBoxChange={this.handleCheckBox}
              /> :
              <div />
            }
          </div>
        </div>
        <div className='buy-buttons'>
          <div className='row newRow buy'>
            <FSFlatButton
              label='BUY NOW'
              onClick={this._onPaymentFormSubmitted}
              className='button buy-button'
              disabled={this.props.disableButtonsWhileLoading}
            />
          </div>
          <div className='row newRow cancel'>
            <FSFlatButton
              label='CANCEL'
              onClick={this.props.cancelAction}
              className='button cancel-button'
              disabled={this.props.disableButtonsWhileLoading}
            />
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./modules/DataExports/components/PurchaseData/children/Payment/children/NewPayment/NewPayment.js